import Vue from 'vue'
import { ActionTree, MutationTree } from "vuex"
import { PortalState } from './portalState'
import { RootState } from '../rootState'

const state: PortalState = {
    atendimentos: [],
    projetos: [],
    tarefas: [],

    atendimentosCarregados: false,
    projetosCarregados: false,
    tarefasCarregadas: false
}

const actions: ActionTree<PortalState, RootState> = {
    carregarUltimosAtendimentos({ commit }) {
        Vue.http.get('/api/portal/ultimosatendimentos')
            .then(res => {
                commit('setAtendimentos', res.body);
            })
            .catch(err => {
                commit('addErro', err.respose?.data?.erro ?? err.message, { root: true })
            })
    },
    carregarProjetos({ commit }) {
        Vue.http.get('/api/portal/projetos')
            .then(res => {
                commit('setProjetos', res.body);
            })
            .catch(err => {
                commit('addErro', err.respose?.data?.erro ?? err.message, { root: true })
            })
    },
    carregarUltimasTarefas({ commit }) {
        Vue.http.get('/api/portal/ultimastarefas')
            .then(res => {
                commit('setTarefas', res.body);
            })
            .catch(err => {
                commit('addErro', err.respose?.data?.erro ?? err.message, { root: true })
            })
    }
}

const mutations: MutationTree<PortalState> = {
    setAtendimentos(state, atendimentos) {
        state.atendimentos = atendimentos;
        state.atendimentosCarregados = true;
    },
    setProjetos(state, projetos) {
        state.projetos = projetos;
        state.projetosCarregados = true;
    },
    setTarefas(state, tarefas) {
        state.tarefas = tarefas;
        state.tarefasCarregadas = true;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}